import { Controller } from "@hotwired/stimulus"

// Wstawia domyślną (systemową) treść prompta do edytora Lexical.
// Tylko podgląd - nic nie zapisuje, user sam decyduje czy wysłać formularz.
export default class extends Controller {
  static values = { content: String }

  // Edytora szukamy w obrębie formatki - na stronie bywa kilka edytorów (np. modal AI)
  editorElement() {
    const form = this.element.closest("form")
    return (form || document).querySelector("[data-controller~=\"lexical-markdown\"]")
  }

  insert() {
    const editor = this.editorElement()
    if (!editor) return

    editor.dispatchEvent(new CustomEvent("lexical:set-content", {
      detail: { markdown: this.contentValue },
    }))
  }
}
